module.exports = __webpack_public_path__ + "static/media/Harsh-Mariwala.96e4764a.png";